import { Injectable } from '@angular/core';
import { ActivatedRoute, ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { AuthService } from './auth.service';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivate {
  constructor(private authService :AuthService, private router :Router, private route :ActivatedRoute) {
    const initialRoute = window.location.href;
    let lastSlashIndex = initialRoute.lastIndexOf("/");
    let pageName = initialRoute.substring(lastSlashIndex + 1);
    console.log("page" + pageName);
    localStorage.setItem("pageName", pageName );
  }

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree { 
      if (this.authService.isAuthenticated() && this.authService.hasAuthorized()){
        return true;
      } else {
        window.location.href = environment.authUrl + '?client_id=' + environment.clientId + '&response_type=code&scope=email+openid+profile&redirect_uri=' + environment.redirectCallBackUrl;
        return false ;
      }  
  }  
}
